<template>
    <TheModal class="sm" @close="$router.push({ name: 'vm', params: $route.params })">
        <template v-slot:head>
            Создание чека коррекции
            <a target="_blank" :href="getKBLink('correction')" class="btn btn-link text-nowrap ml-2 px-0"><i class="tlm-icon-question-circle" /></a>
        </template>

        <FormVmCorrection ref="form" @submit="submit" v-if="isAvailable" />

        <p v-else>
            К сожалению функция создания чек-коррекции не доступна для текущей версии ФФД. Вы можете создать чек-коррекции в личном кабинете оператора облачных касс
        </p>
    </TheModal>
</template>

<script>
import store from '@/store'
import TheModal from '@/components/TheModal'
import FormVmCorrection from '@/components/FormVmCorrection'

import KBLinksService from '@/services/KBLinksService'

import { toastSuccess, toastError } from '@/dialogs'

export default {
    components: {
        TheModal,
        FormVmCorrection
    },

    computed: {
        company() {
            return store.state.company.profile.data
        },

        isAvailable() {
            if (!this.company.crt || !this.company.crt.credentials || !this.company.crt.credentials.ffd_version) {
                return true
            }

            return this.company.crt.credentials.ffd_version !== '1.2'
        }
    },

    methods: {
        async submit(payload) {
            let response = await this.$store.dispatch('vm/correction/save', {
                id: this.$route.params.id,
                payload
            })

            if (response !== false) {
                toastSuccess('Отправлено')
                this.$router.push({ name: 'vm', params: this.$route.params })
            } else {
                this.$refs.form.mixinApiErrors(this.$store.state.vm.correction.error)
                return toastError('Ошибка')
            }
        },

        getKBLink(key) {
            return KBLinksService.get(key)
        }
    }
}
</script>
